import { put, takeEvery } from "redux-saga/effects";
import LoginApiRequests from "../../Services/Login";
import { GET_ADD_PRODUCT, GET_ADD_RFQ, GET_CHOOSE_TYPE, GET_ROLES, GET_SEND_OTP, GET_UPDATE_ORDER, GET_UPDATE_RFQ, GET_VERIFY_OTP, SET_ROLES } from "../ConstAction";
import { toast } from 'react-toastify';
import { storage } from "../../Config/Storage";
import { INFO } from "../../Routes/constURL";

function* getsendotp(data) {
    try {
        let response = yield LoginApiRequests.requestlogin(data.data);

        if (response.data.status) {
            toast.success(response.data.message)
            storage.set.phonenumber(data?.data?.phone)
            storage.set.phone(response?.data?.data?.id)
            setTimeout(() => {
                data.setComponent("verify")
                data.setLoading(false)
            }, 2000);

        } else {
            toast.error("Enable send otp")
            data.setLoading(false)
        }

    } catch (err) {
        data.setLoading(false)

    }
}

function* getverifyotp(data) {
    try {
        let response = yield LoginApiRequests.requestverify(data.data);
        if (response.data.status) {
            if (response?.data?.token) {
                storage.set.auth(response?.data?.token)
                storage.set.loggedinuser(response?.data?.data)
                for (const item of data?.orders || []) {
                    yield put({
                        type: GET_UPDATE_ORDER,
                        data: {
                            id: item.id,
                            user_id: response.data.data.id,
                        },
                    });
                }

                const rfq = storage.fetch.rfq()
                if (rfq)
                    yield put({
                        type: GET_UPDATE_RFQ,
                        data: { Status: "published", user_id: response.data.data.id, }
                    })
                data.navigate(INFO)
            } else {
                data.setComponent("")
            }
            data.setLoading(false)
            toast.success("OTP verified successfully.")
        } else {
            toast.error("Please enter valid OTP.")
            data.setLoading(false)
        }
    } catch (err) {
        toast.error("Please enter valid OTP.")
        data.setLoading(false)
    }
}
function* getchoosetype(data) {
    try {
        let response = yield LoginApiRequests.requestchoosetype(data.data);

        if (response.status) {
            storage.set.auth(response?.token)
            storage.set.loggedinuser(response.data)
            for (const item of data?.orders || []) {
                yield put({
                    type: GET_UPDATE_ORDER,
                    data: {
                        id: item.id,
                        user_id: response.data.id,
                    },
                });
            }

            const rfq = storage.fetch.rfq()
            if (rfq)
                yield put({
                    type: GET_UPDATE_RFQ,
                    data: { Status: "published", user_id: response.data.id, }
                })
            data.navigate(INFO)
            setTimeout(() => {
                data?.navigate(INFO)
                data?.setLoading(false)
                toast.success("User logged In Successfully.")
            }, 1000);

        }
        data?.setLoading(false)

    } catch (err) {
        
        toast.error("Please select user type.")
        data?.setLoading(false)
    }
}
function* getroles() {
    try {
        let response = yield LoginApiRequests.requestroles();
        yield put({
            type: SET_ROLES,
            response,
        })
    } catch (err) { }
}

// Defination of all Saga
function* Loginsaga() {
    yield takeEvery(GET_SEND_OTP, getsendotp);
    yield takeEvery(GET_VERIFY_OTP, getverifyotp);
    yield takeEvery(GET_CHOOSE_TYPE, getchoosetype);
    yield takeEvery(GET_ROLES, getroles);
}
export default Loginsaga;